import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import ListMerchantAtrribution from './List/AsyncList';

function Routes() {
  return (
    <DocumentTitle title="Merchant Attribtion">
      <Route
        path="/merchant-attribution"
        exact
        component={ListMerchantAtrribution}
      />
    </DocumentTitle>
  );
}

export default Routes;
